/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import HideableContainer from 'components/Common/HideableContainer';
import HGGFullLogo from 'assets/HGG-fullLogo.svg';
import SignInNavBar from '../SignInNavBar';
import Styles from './index.module.css';

export default function SideBar({ step, onChangeStep, ...props }) {
  const history = useHistory();
  return (
    <div className={Styles.mainContainer} {...props}>
      <div onClick={() => history.push('/Home')} className={Styles.logoContainer}>
        <img onClick={() => history.push('/Home')} src={HGGFullLogo} alt="HGGFullLogo" />
      </div>
      <div className={Styles.navContainer}>
        <div className={Styles.marketingNavBarContainer}>
          <div className={Styles.marketingNavBar}>
            <HideableContainer>
              <SignInNavBar step={step} onChangeStep={onChangeStep} />
            </HideableContainer>
          </div>
        </div>
      </div>
    </div>
  );
}

SideBar.propTypes = {
  step: PropTypes.string,
  onChangeStep: PropTypes.func,
};

SideBar.defaultProps = {
  step: '',
  onChangeStep: () => {},
};
